module.exports = __webpack_public_path__ + "img/trx.230a3701.png";